
import "../fonts/swatch.css";

const swatchItaly = {
    tagUrl: "//eu4-track.inside-graph.com/gtm/IN-1000978/include.js",
    logo: "/assets/swatch-logo.svg",
    customCss: () => {
        var flag = document.createElement("div");
        flag.classList.add("flag");
        let flagImage = document.createElement("img");
        flagImage.setAttribute("src", "/assets/italy.png");
        flagImage.setAttribute("alt", "");
        flag.appendChild(flagImage);
        document.querySelector("#root").appendChild(flag);

        var css = "#root {font-family: Swatch, 'Nunito Sans', Arial} .flag {position: absolute; right: 16px; top: 16px; } .flag img {height: 20px;}";
        var style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    },
}

export default swatchItaly;